import React, { useState } from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import { all_routes } from '../../../router/all_routes';

interface BannerProps {
    apiValues: any;
    apiValues2: any;
}



const Topcategories: React.FC<BannerProps> = ({ apiValues, apiValues2 }) => {
    console.log("apiValuesakashakashapiValues", apiValues)
    const [clickedIndex, setClickedIndex] = useState<number | null>(null);
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

    const handleCardClick = (index: number) => {
        setClickedIndex(index === clickedIndex ? null : index); // toggle same card
    };


    const [selectedCard, setSelectedCard] = useState(null);


    const closeOverlay = () => {
        setSelectedCard(null);
    };


    const route = all_routes

    const categoriesslider = {

        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true, // Enable auto-scroll
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* Top Categories */}
            <div className="section how-it-works">
                <div className="container">
                    <div
                        className="d-flex align-items-center justify-content-between flex-wrap gap-3 "
                    >
                        <div className="section-header">
                            <span className="fw-medium text-secondary fs-18 fw-bold mb-2 d-inline-block">
                                {apiValues2?.title}
                            </span>
                            <h2 className="mb-2 text-[#1D1753]">
                                {apiValues2?.description}
                            </h2>
                            <p className='text-[#1D1753]'>
                                {apiValues2?.miniDescription}
                            </p>
                        </div>
                        {/* <div className="mb-2">
                            <Link to={route.courseCategory2} className="btn btn-secondary btn-xl">
                                View all Countries
                            </Link>
                        </div> */}
                    </div>
                    {/* <Slider {...categoriesslider}> */}



                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                        {Array.isArray(apiValues) &&
                            apiValues?.map((item: any, index: number) => (
                                <div
                                    key={index}
                                    className="card newGradient rounded-lg overflow-hidden border bg-white cursor-pointer transition flex flex-col"
                                >
                                    <Link to={`/study_destination_country/${item?.parentId}`} className="flex flex-col h-full">
                                        {/* Image */}
                                        <div className="h-[220px] w-full p-2 overflow-hidden">
                                            <ImageWithBasePath
                                                source={item?.cardbgImageUrl}
                                                alt={item?.countryName}
                                                className="w-full h-full object-cover rounded-md"
                                            />
                                        </div>

                                        {/* Content */}
                                        <div className="text-center flex flex-col flex-1">
                                            {/* Flag + Name */}
                                            <div className="flex flex-col items-center gap-2 -mt-6">
                                                <img
                                                    src={item?.countryImage}
                                                    alt={item?.countryName}
                                                    className="w-12 h-12 rounded-full border-4 border-white object-cover"
                                                />
                                                <h3 className="text-lg font-semibold">{item?.countryName}</h3>
                                            </div>

                                            {/* Description */}
                                            <p className="font-medium line-clamp-3 px-2">{item?.bannerTitle}</p>

                                            {/* Learn More - always bottom */}
                                            <div className="px-4 flex justify-center items-center mt-auto pt-4 pb-4">
                                                <Link to={`/study_destination_country/${item?.parentId}`}>
                                                    <button className="learn-more-btn">
                                                        <span className="btn-text">Learn More</span>
                                                        <span className="btn-arrow">→</span>
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                            ))}
                    </div>






                    {/* </Slider> */}
                </div>
            </div >
            {/* /Top Categories */}
        </>

    )
}

export default Topcategories
